import React, { FC } from "react";
import { Card, CardBody } from "@heroui/react";
import { Icon } from "@iconify/react";
import Typography from "../typography/Typography";

type AlertBlockProps = {
  data: DataAlert[];
  addContent?: React.ReactNode;
  customIcon?:any;
  type?: "default" | "rounded";
  className?: string;
  titleColor?: string;
}

type DataAlert = {
  severity: "info" | "success" | "warning" | "error";
  title?: string;
  description?: string; 
  descriptions?: string[];
  icon?: React.ReactNode;
}
const AlertBlock:FC<AlertBlockProps> = ({ data, addContent, className, type, titleColor }) => {
  const getIcon = (severity?: string) => {
    switch (severity) {
      case "success":
        return <Icon icon="solar:check-circle-broken" width="32" height="32" className="text-success" />;
      case "warning":
        return <Icon icon="solar:danger-triangle-broken" width="32" height="32" className="text-warning" />;
      case "error":
        return <Icon icon="solar:close-circle-broken" width="32" height="32" className="text-danger" />;
      case "info":
      default:
        return <Icon icon="solar:info-circle-broken" width="32" height="32" className="text-primary" />;
    }
  };
  if(type === "rounded") {
    if(data && data.length === 1 && data[0].severity === "success"){
      return(
        <div className="flex flex-col gap-[8px]">
          {data && data.length > 0 && data.map((item, index) => (
            <div key={index} className="bg-green-50 border border-green-200 rounded-xl py-[12px] px-[16px]">
              <div className="flex items-center gap-[16px]">
                <div className="w-[36px] h-[36px]">
                  <Icon icon="solar:check-circle-broken" width="36" height="36" className="text-success" />
                </div>
                <span className="text-[#0E793C] text-[14px] leading-[20px] font-medium">{item?.description}</span>
              </div>
            </div>
          ))}
        </div>
      )
    }
    return(
      <div className="flex w-full flex-col gap-[8px]">
        {data && data.length > 0 && data.map((item, index) => (
          <div key={index} className={`w-full bg-[#fee7ef] border-2 border-[#f7d0dd] rounded-[12px] py-[12px] px-[16px] shadow-sm ${className}`}>
            <div className="flex items-center gap-[16px]">
              <div className="w-[39px] h-[39px] bg-[#fee7ef] border border-[#f7d0dd] rounded-[30px] flex items-center justify-center flex-shrink-0">
                <Icon 
                  icon="mingcute:information-fill" 
                  width="19" 
                  height="19" 
                  className="text-[#c41552]"
                />
              </div>
              <p className="text-[#c41552] text-[14px] font-medium leading-[20px]">
                {item?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    )
  }
  return(
    <Card className={`border border-l-[3px] border-l-[#006FEE] rounded-r-[12px]  rounded-l-none shadow-sm bg-[#FAFAFA] ${className}`}>
      <CardBody className="p-[16px] flex flex-col gap-[24px] ">
        {data && data.length > 0 && data.map((item, index) => (
          <div key={index} className="flex items-start gap-[16px]">
            {/* @ts-ignore */}
            <div className="min-w-[36px]">
              {item?.icon || getIcon(item?.severity)}
            </div>
            <div className="max-w-[750px] flex flex-col items-start">
              <Typography variant="body2" className={`${titleColor ? `!text-[${titleColor}]` : '!text-[#006fee]'} font-medium leading-[20px] mb-[2px]`}>
                {item?.title||'Подтвердите код'}
              </Typography>
              {item?.descriptions && item?.descriptions.length > 0 ? item?.descriptions.map((desc:any, idx:any) => (
                <>
                  <Typography variant="body2" key={idx} className="text-[#71717a] leading-[20px]">
                    <span dangerouslySetInnerHTML={{ __html: desc }} />
                  </Typography>
                  {idx+1 === item?.descriptions?.length ? null : (<><br/></>)}
                </>

              ))
              :
                !addContent &&
                 <Typography variant="body2" className="text-[#71717a] leading-[20px]">
                  <span dangerouslySetInnerHTML={{ __html: item?.description||'Пожалуйста, вставьте сгенерированный нами код в описание своего профиля, затем нажмите кнопку «Проверить». После успешной проверки вы сможете удалить этот код из описания.' }} />
                </Typography>
                
              }
              {addContent && addContent}
              {/* <p className="text-[14px] text-[#006FEE] leading-[20px] border-[1px] py-[2px] rounded-[20px] bg-[#E0EDFC] px-[8px] border-[#E0EDFC] ">
                {generatedCode}
              </p> */}
            </div>
          </div>
        ))}
      </CardBody>
    </Card>
  )
}

export default AlertBlock;
